import { render, staticRenderFns } from "./AddExpenseModal.vue?vue&type=template&id=52d251ca&scoped=true"
import script from "./AddExpenseModal.vue?vue&type=script&lang=js"
export * from "./AddExpenseModal.vue?vue&type=script&lang=js"
import style0 from "./AddExpenseModal.vue?vue&type=style&index=0&id=52d251ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d251ca",
  null
  
)

export default component.exports